export default {
    'collection-points-page': () => import(
        /* webpackChunkName: 'vue-components/collection-points-page' */
        'framework/components/collection-points-page/collection-points-page.vue'
    ),
};
